import { Box, IconButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { DragHandle, KeyboardArrowRight } from "@mui/icons-material";
import { NodeModel } from "@minoru/react-dnd-treeview";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/lib/i18n";
import { If } from "@/features/shared/components";
import { NavigationElement } from "@/lib/api";
import IconAvatar from "@/components/icon-avatar/icon-avatar";

import EditOverviewItemMenu from "./edit-overview-item-menu";
import ExpandFolderButton from "./expand-folder-button";
import { StyledListItem } from "./styles";

type Props = {
  node: NodeModel;
  isOpen: boolean;
  onToggle: (id: string | number) => void;
  dragAndDropEnabled: boolean;
};

const OverviewItem = ({ node, isOpen, onToggle, dragAndDropEnabled }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const data = node.data as NavigationElement;
  const isFolder = !data.page_id;

  const { text } = node;

  const openPage = () => {
    navigate(`../page/${data.page_id}`);
  };

  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore:  The `component` typescript error seems to be and mui issue. Works fine.
    <StyledListItem component="div" className="tree-node">
      <ExpandFolderButton
        isVisible={isFolder}
        isOpen={isOpen}
        onToggle={() => onToggle(node.id)}
      />

      <ListItemIcon sx={{ minWidth: 48, color: "black" }}>
        {data.icon && <IconAvatar icon={data.icon} />}
      </ListItemIcon>

      <ListItemText primary={text} />

      <If condition={!dragAndDropEnabled}>
        <EditOverviewItemMenu navigationElement={data} />

        {/* Arrow Icon */}
        <Box sx={{ width: 40 }}>
          <If condition={!isFolder}>
            <Tooltip title={t("admin.pages.overview.open_page_tooltip")} onClick={openPage}>
              <IconButton>
                <KeyboardArrowRight />
              </IconButton>
            </Tooltip>
          </If>
        </Box>
      </If>

      {/* Button Drag Indicatior */}
      <If condition={dragAndDropEnabled}>
        <IconButton>
          <DragHandle />
        </IconButton>
      </If>
    </StyledListItem>
  );
};

export default OverviewItem;
